import { POLICIES, type PolicyKey } from "../commons/policies";
import { usePermissionsContext } from "../context/PermissionsContext";

/**
 * Synchronous boolean for an application capability. Fail-closed: false until
 * PermissionsProvider has a result for the matching policy (several capabilities
 * may share one, see POLICIES).
 */
export const usePermission = (policy: PolicyKey): boolean => {
    const { permissions } = usePermissionsContext();
    return permissions[POLICIES[policy]] ?? false;
};
